import AddIcon from '@mui/icons-material/Add';
import { Box, ToggleButton, ToggleButtonGroup, useTheme } from "@mui/material";
import Shbutton from "../../../../components/theme/buttons/Shbutton";

import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import cx from 'classnames';
import { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import RelationProductCard from "../../../../components/global/cards/products/relation/RelationProductCard";
import MpAddProduct from "../../../../components/global/ModalsProgression/MpAddProduct/MpAddProduct";
import ButtonGroup from "../../../../components/theme/buttons/ButtonGroup";
import ShDataGrid3 from "../../../../components/theme/datagrid3/ShDataGrid3";
import ShCopyButton from "../../../../components/theme/ShCopy";
import SidepanelLoader from "../../../../components/theme/sidepanel2/SidepanelLoader";
import ShTextSkeleton from "../../../../components/theme/skeleton/ShTextSkeleton";
import Text from "../../../../components/theme/text/Text";
import { selectUserPermission } from "../../../../newapi/user/authentication/authSlice";
import { useExportProductsMutation, useGetProductsQuery } from "../../../../newapi/warehouse/productSlice";
import { tokens } from "../../../../theme";
import { UserPrivileges } from "../../../../utils/permissions";
import { PRODUCT_FILTER_KEYS } from '../../../../components/global/DataGrid/Filter';
import { useExportStockStatusMutation } from '../../../../newapi/warehouse/stockSlice';
import { showToastPromise } from '../../../../utils/toasts';
import { AMProductExport } from '../../../../components/global/Modals/ActionModal/AMProductExport';
import MDynamicValues from '../../../../components/global/Modals/MDynamicValues';
import { useGetSuppliersSelectQuery } from '../../../../newapi/global/supplier/supplierSlice';


const SpStockDetails = SidepanelLoader(() => import("../../../../components/global/Sidepanels/SpStockDetails/SPStockDetails"));

const GridActions = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box 
        
            sx={{
                display:"flex",
                gap:2,

                "@media screen and (max-width: 47.9375em)" : {
                    // mr:"-24px",
                    width:1,
                }
            }}
        >

            <ButtonGroup version={2}>
                <Shbutton
                    onClick={props.handleFilterPopoverClick}
                    className={"group-btn"}
                    // onClick={props.action}
                    color={"primaryGrey"}
                    variant="contained"
                    endIcon={<DownloadOutlinedIcon/>}
                >
                    {t('export')}
                </Shbutton>
                {props.hasCreatePermission && (
                <Shbutton 
                    className={"group-btn"} 
                    color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                    onClick={() => props.handleOpen(true)}
                    endIcon={<AddIcon/>}
                    variant="contained"
                >
                    {t("new_product")}
                </Shbutton>
                )}
            </ButtonGroup>
        </Box>
    );
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    filter: [
        PRODUCT_FILTER_KEYS.STATE,
        PRODUCT_FILTER_KEYS.SUPPLIER,
        PRODUCT_FILTER_KEYS.STOCK,
        PRODUCT_FILTER_KEYS.QUARANTINE, 
        PRODUCT_FILTER_KEYS.SAFETY_STOCK,
        PRODUCT_FILTER_KEYS.BACKORDER_WITH_INBOUND,
        PRODUCT_FILTER_KEYS.BACKORDER_WITHOUT_INBOUND,
        PRODUCT_FILTER_KEYS.ADDON
    ],
};

const ProductOverview = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [data, setData] = useState([]);
    const [config, setConfig] = useState({
        isVirtual: false,
        showInactive: false,
    });
    const [isExtended, setIsExtended] = useState(false);

    const hasCreatePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RP_PRODUCT_MANAGE])
    );

    const [filterAnchorEl, setFilterAnchorEl] = useState(null);
    const filterPopoverOpen = Boolean(filterAnchorEl);
    const filterPopoverId = filterPopoverOpen ? 'simple-popover' : undefined;

    const handleFilterPopoverClick = (event) => {
        setFilterAnchorEl(event.currentTarget);
    };

    const handleFilterPopoverClose = () => {
        setFilterAnchorEl(null);
        // setExportAnchorEl(null);
    };

    const [addLotModalOpen, setAddLotModalOpen] = useState(false);
    const addLotModal = {
        open: addLotModalOpen,
        setOpen: setAddLotModalOpen
    }

    const [productExportModalOpen, setProductExportModalOpen] = useState(false);
    const productExportModal = {
        open: productExportModalOpen,
        setOpen: setProductExportModalOpen
    }

    const { data: suppliers } = useGetSuppliersSelectQuery();


    const [spStockLoading, setSpStockLoading] = useState();

    const [productId, setProductId] = useState();
    const productIdRef = useRef(productId);
    
    const getProductDetails = (params) => {
        if (!params) return;
    
        const newProductId = parseInt(params.row.id);
        // Only update state if the productId has actually changed
        if (productIdRef.current !== newProductId) {
            if(!spStockLoading){
                setSpStockLoading(true);
            }
            setProductId(newProductId);
            productIdRef.current = newProductId; // Update the ref to the new value
        }
        
            setIsExtended(true);
    };
    const [exportProducts, {isLoading: isExporting}] = useExportProductsMutation();
    const exportProductsCall = async (values) => {
        const exportPromise = exportProducts({
            isVirtual: false,
            suppliers: values?.suppliers,
            safetyStock: values?.safetyStock,
        }).unwrap();

        showToastPromise(
            exportPromise,
            t,
            {
                pending: t('export_processing') || 'Processing export...',
                success: t('export_success') || 'Export completed successfully',
                error: t('export_failed') || 'Export failed'
            }
        ).then((result) => {
            // Check if it's a background processing response
            if (result.processing) {
                // The toast will already show the message from the backend
                // You could add additional handling here if needed (e.g., show a link to check export status)
                console.log('Export is being processed in background. Export ID:', result.exportId);
            }
        }).catch((error) => {
            console.error("Export failed", error);
        });
    }

    const [exportStockStatus, {isLoading: isStockExporting}] = useExportStockStatusMutation();
    const exportStockStatusCall = async (values) => {
        try {
            await exportStockStatus({ targetDate: values.targetDate });
            // Download is handled automatically in the mutation
        } catch (error) {
            console.error("Export failed", error);
        }
    }

    const handleOpen = () => {
        setAddModalOpen(true);
    }

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
            mobileActions: <GridActions 
                handleFilterPopoverClick={handleFilterPopoverClick}
                // isExporting={isExporting}  
                hasCreatePermission={hasCreatePermission} 
                handleOpen={handleOpen} 
                // exportProducts={exportProductsCall}
            />,
                
        });

        return () => {
            
        }
    },[config,isExporting,hasCreatePermission,exportProductsCall,handleOpen]);


    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const handleClose = () => {
        setAddModalOpen(false);
    };



    const columns = [
        {
            field: "sku",
            headerName: t("sku"),
            width:210,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Box sx={{
                        minWidth:"100%",
                        height:"100%",
                        display:"flex",
                        alignItems:"center",
                        position:"relative",
                        whiteSpace:"nowrap",
                        wordBreak:"keep-all",
                        textOverflow:"ellipsis",
                        overflow:"hidden",
                        ".copyel": {
                            opacity:0,
                        },
                        "&:hover .copyel": {
                            opacity:1,
                        }
                    }}>
                        <Text noBreak>{params.row.sku}</Text>
                        <ShCopyButton
                            styles={{button:{
                                background:theme.palette.mode === "dark" ? colors.grey[600] :  colors.grey[200],
                                color: colors.txt["primary"],
                                "&:hover" : {
                                    background:theme.palette.mode === "dark" ? colors.grey[500] :colors.grey[300],

                                }
                            }}} 
                            sx={{position:"absolute",right:0,zIndex:3000}} 
                            className={"copyel"} 
                            closeAfter={1500} 
                            value={params.row.sku}
                        ></ShCopyButton>
                        {params.row.state === 'deleted' ? <><hr/><Text light sx={{
                            marginRight: 5
                        }}>{t('deleted')}</Text></> : <></>}
                    </Box>
                );
            }
        },
        {
            field: "description",
            headerName: t("description"),
            flex:3,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.description
            },
        },
        {
            field: "barcode",
            headerName: t("barcode"),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Box sx={{
                        minWidth:"100%",
                        height:"100%",
                        display:"flex",
                        alignItems:"center",
                        position:"relative",
                        whiteSpace:"nowrap",
                        wordBreak:"keep-all",
                        textOverflow:"ellipsis",
                        overflow:"hidden",
                        ".copyel": {
                            opacity:0,
                        },
                        "&:hover .copyel": {
                            opacity:1,
                        }
                    }}>
                        <Text noBreak>{params.row.barcode}</Text>
                        <ShCopyButton
                            styles={{button:{
                                background:theme.palette.mode === "dark" ? colors.grey[600] :  colors.grey[200],
                                color: colors.txt["primary"],
                                "&:hover" : {
                                    background:theme.palette.mode === "dark" ? colors.grey[500] :colors.grey[300],

                                }
                            }}} 
                            sx={{position:"absolute",right:0,zIndex:3000}} 
                            className={"copyel"} 
                            closeAfter={1500} 
                            value={params.row.barcode}
                        ></ShCopyButton>
                    </Box>
                )
            },
        },
        {
            field: "supplier",
            headerName: t("supplier"),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.supplier?.name ?? "";
            },
        },
        {
            field: "safetyStock",
            headerName: t("safety_stock"),
            width:180,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                if (params.row.safetyStock && (!params.row.stock?.total_available || params.row.safetyStock > params.row.stock.total_available)) {
                    return (
                        <Text bold color={colors.red[400]}>
                            {params.row.safetyStock}
                        </Text>
                    );
                } else {
                    return params.row.safetyStock
                }
            },
        },
        {
            field: "stock_quantity",
            headerName: t("stock_quantity"),
            width:140,
            filter:PRODUCT_FILTER_KEYS.STOCK,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (params.row.stock && params.row.stock.total_quantity ? params.row.stock.total_quantity : 0);
            },
        },
        {
            field: "stock_available",
            headerName: t("stock_available"),
            width:160,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (params.row.stock && params.row.stock.total_available ? params.row.stock.total_available : 0);
            },
        },
        {
            field: "stock_quarantine",
            headerName: t("stock_quarantine"),
            width:160,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (params.row.stock && params.row.stock.total_quarantine && params.row.stock.total_quarantine > 0 ? params.row.stock.total_quarantine : "");
            },
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (cellValues) => {
                return (
                    <RelationProductCard
                        onClick={() => getProductDetails(cellValues)}
                        skeleton={cellValues.row.skeleton}
                        {...cellValues.row}
                    />
                )
            }
        }
    ];

    return (
        <Box height={1} display={"flex"} flexDirection={"column"}>
            <ShDataGrid3 key={theme.palette.mode}
                gridKey="relations.products.overview"
                content={useGetProductsQuery}
                config={config}
                gridActions={<GridActions
                    // isExporting={isExporting}
                     hasCreatePermission={hasCreatePermission}
                     handleOpen={handleOpen}

                    handleFilterPopoverClick={handleFilterPopoverClick}
                    //  exportProducts={exportProductsCall}
                    //  exportStock={exportStockStatusCall}
                     >

                     </GridActions>
                }
                title={t('overview')}
                onRowClick={getProductDetails}
                gridOptions={gridOptions}
                columns={columns}
                sortModel={{field: columns[0].field,type:"ASC"}}
                rows={data}>
            </ShDataGrid3>
            {spStockLoading && 
                <SpStockDetails
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    productId={productId}
                />
            }
            <MpAddProduct onOpen={() => addModal.setOpen(true)} onClose={() => addModal.setOpen(false)} open={addModal.open} handleClose={handleClose} />

            <AMProductExport
                id={filterPopoverId}
                open={filterPopoverOpen}
                anchorEl={filterAnchorEl}
                onClose={handleFilterPopoverClose}

                exportProducts={() => productExportModal.setOpen(true)}
                exportStockModal={() => addLotModal.setOpen(true)}
            />

            <MDynamicValues
                open={productExportModal.open}
                handleClose={() => productExportModal.setOpen(false)}
                title={t("export_products")}
                labelWidth={280}
                fields={[
                    { name: "suppliers", label: t("suppliers"), type: "list", multiple: true, search: true, options: suppliers ?? [] },
                    { name: "safetyStock", label: t("below_safetystock"), type: "boolean" }
                ]}
                onConfirm={(values) => exportProductsCall(values)}
            />

            <MDynamicValues
                open={addLotModal.open}
                handleClose={() => addLotModal.setOpen(false)}
                title={t("export_stock")}
                labelWidth={80}
                fields={[
                    // { name: "lot", label: t("lot"), type: "text" },
                    { name: "targetDate", label: t("date"), type: "date" }
                ]}
                onConfirm={(values) => exportStockStatusCall(values)}
            />
        </Box>
    );
}
export default ProductOverview;